

















































































































































































































































































































































































import { SwipeDetector } from 'swipedetector'
import timezones from 'timezones.json'
import Moment from 'moment-timezone/builds/moment-timezone-with-data-2012-2022'
import fscreen from 'fscreen'

export default {
  name: 'left-menu',
  data() {
    return {
      isOpen: false,
      subMenu: null,
      timezones,
      isFullscreen: false
    }
  },
  computed: {
    interpolate() {
      return this.$store.state.persistent.interpolate
    },
    airspace() {
      return this.$store.state.persistent.airspace
    },
    xcplanner() {
      return this.$store.state.persistent.xcplanner
    },
    colorblind() {
      return this.$store.state.persistent.colorblind
    },
    experimental() {
      return this.$store.state.persistent.experimental
    },
    contributor() {
      return this.$store.getters['auth/isContributor']
    },
    email() {
      return this.$store.getters['auth/email']
    },
    expiration() {
      return this.$store.getters['auth/expiration']
    },
    news() {
      return this.$store.getters['news/articles']
    },
    unreadNewsCount() {
      return this.$store.getters['news/unreadCount']
    },
    cordova() {
      return this.$store.state.runtime.cordova
    },
    mobileBrowser() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera

        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
      }

      if (/android/i.test(userAgent)) {
        return 'Android'
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }

      return false
    },
    currentTimezone() {
      return this.$store.state.persistent.timezone
    },
    timezoneOveride() {
      return this.$store.state.persistent.timezoneOveride
    },
    fullscreen() {
      if (!fscreen.fullscreenEnabled || this.cordova) return null
      return this.isFullscreen
    }
  },
  created() {
    if (fscreen.fullscreenEnabled && !('cordova' in window)) {
      window.addEventListener('keydown', this.escape)
      fscreen.addEventListener('fullscreenchange', this.fullscreenChange, false)
    }
  },
  mounted() {
    const swipe = new SwipeDetector(this.$el).emitter
    swipe.on('right', this.close)
    swipe.on('left', this.close)
  },
  methods: {
    doAction() {},
    escape(event) {
      if (this.$data.isOpen && event.keyCode === 27) {
        this.close()
      }
    },
    close() {
      this.isOpen = false
      this.openMenu('favorites')
      // this.subMenu = null
    },
    toggleSubMenu(event, menu) {
      const menuSplit = menu.split('/') || []
      if (menu === this.subMenu) {
        menuSplit.pop()
        this.subMenu = menuSplit.join('/')
      } else {
        this.subMenu = menu
        // if (true || menuSplit[0] === 'settings') {
        this.$nextTick(() => this.scrollMenu(event.target))
        // }
      }
    },
    setLayer(layer) {
      this.$store.dispatch('persistent/setLayer', layer)
      this.close()
    },
    toggleInterpolation() {
      this.$store.dispatch('persistent/toggleInterpolation')
      this.close()
    },
    toggleAirspace() {
      this.$store.dispatch('persistent/toggleAirspace')
      this.close()
    },
    toggleXcplanner() {
      this.$store.dispatch('persistent/toggleXcplanner')
      this.close()
    },
    toggleColorblind() {
      this.$store.dispatch('persistent/toggleColorblind')
      this.close()
    },
    toggleExperimental(event) {
      this.$store.dispatch('persistent/toggleExperimental')
      if (this.experimental) {
        this.$nextTick(() => {
          this.scrollMenu(document.getElementById('menu-experimental'))
        })
      }
    },
    toggleFullscreen() {
      if (this.isFullscreen) {
        fscreen.exitFullscreen()
      } else {
        fscreen.requestFullscreen(document.documentElement)
      }
      this.close()
    },
    fullscreenChange() {
      if (fscreen.fullscreenElement === null) {
        this.isFullscreen = false
      } else {
        this.isFullscreen = true
      }
    },
    openContribution() {
      window.openLink(window.portalLink('users/contribute/'))
      setTimeout(() => this.$store.dispatch('runtime/showModal', 'login'), 3000)
      this.close()
    },
    openTour() {
      window.openLink(`https://portal.meteo-parapente.com/tour/`)
      this.close()
    },
    logout() {
      this.$store.dispatch('auth/logout')
      this.openMenu('')
      this.close()
    },
    changePassword() {
      this.$store.dispatch('runtime/showModal', 'password')
      this.close()
    },
    openLogin() {
      this.$store.dispatch('runtime/showModal', 'login')
      this.close()
    },
    addFavorite() {
      /* eslint no-alert: 0 */
      window.promptAsync(this.$pgettext('new favorite prompt', 'Enter a name'), name => {
        if (name === null || name === '') return
        this.$store.dispatch('favorites/add', { name, state: this.$store.state.persistent })
      })
      // this.close()
    },
    loadFavorite(id) {
      this.$store.dispatch('persistent/load', this.$store.state.favorites.list[id].state)
      this.close()
    },
    setHomeFavorite(id) {
      this.$store.dispatch('favorites/setHome', id)
      this.openMenu('favorites')
    },
    renameFavorite(id) {
      /* eslint no-alert: 0 */
      window.promptAsync(this.$pgettext('new favorite prompt', 'Enter the new name'), name => {
        if (name === null || name === '') return
        this.$store.dispatch('favorites/setName', { id, name })
        this.openMenu('favorites')
      })
    },
    updateFavorite(id, name) {
      let text = this.$pgettext('updateFavorite', 'Overwrite favorite "%{ name }"?')
      text = this.$gettextInterpolate(text, { name })
      window.confirmAsync(text, () => {
        this.$store.dispatch('favorites/update', { id, newState: this.$store.state.persistent })
        this.openMenu('favorites')
      })
    },
    deleteFavorite(id, name) {
      let text = this.$pgettext('deleteFavorite', 'Delete favorite "%{ name }"?')
      text = this.$gettextInterpolate(text, { name })
      window.confirmAsync(text, () => {
        this.$store.dispatch('favorites/delete', id)
        this.openMenu('favorites')
      })
    },
    moveToUpFavorite(id) {
      this.$store.dispatch('favorites/moveToUp', id)
      this.openMenu('favorites')
    },
    resetStore() {
      const text = this.$pgettext('resetStore', 'Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!')
      window.confirmAsync(text, () => {
        this.$store.dispatch('persistent/resetStore')
        this.$store.dispatch('favorites/resetStore')
        this.$store.dispatch('news/resetStore')
        this.$store.dispatch('auth/resetStore')
        this.close()
      })
    },
    openNews({ url, id }) {
      window.openLink(url)
      this.$store.dispatch('news/setRead', id)
    },
    openCommunity() {
      window.openLink('https://community.meteo-parapente.com')
      this.close()
    },
    changeLanguage(lang) {
      this.$store.dispatch('persistent/setLang', lang)
      this.openMenu('settings')
    },
    openTranslatePage() {
      window.openLink('https://poeditor.com/join/project/kmNoPTFkQP')
    },
    openHelp() {
      window.openLink(window.portalLink(''))
      this.close()
    },
    openAndroidApp() {
      window.openLink('market://details?id=com.meteo_parapente')
    },
    openIOSApp() {
      window.openLink('itms-apps://itunes.apple.com/app/id1255974302')
    },
    isMenuOpen(path) {
      return this.subMenu && this.subMenu.search(path) >= 0
    },
    openMenu(event, menu) {
      this.subMenu = menu
      // this.$nextTick(() => this.scrollMenu(event.target))
    },
    toggleTimezoneOveride() {
      this.$store.dispatch('persistent/setTimezoneOveride', !this.timezoneOveride)
      if (!this.timezoneOveride) {
        const timezone = Moment.tz.guess()
        this.$store.dispatch('persistent/setTimezone', timezone)
        // this.openMenu('settings')
      }
    },
    setTimezone(timezone) {
      this.$store.dispatch('persistent/setTimezone', timezone)
      this.$store.dispatch('persistent/setTimezoneOveride', true)
      // this.openMenu('settings')
    },
    scrollMenu(target) {
      try {
        target.scrollIntoView()
        const parent = target.parentNode
        const offset = 40 * 2
        if (parent.scrollTopMax > parent.scrollTop + offset) {
          parent.scrollTop -= offset
        }
      } catch (e) {}
    },
    setWindUnit(unit) {
      this.$store.dispatch('persistent/setWindUnit', unit)
      this.close()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/left-menu.vue